import axios from "axios"
import env from "react-dotenv";

// console.log(env.SERVER_URL)

// desc: Sending the Username and Password to the backend  (login)
// Used in: ./components/Login/Login.js 
 const Login_Post_Call=async (email,password)=>{
  try {

    const response = await axios.post(process.env.REACT_APP_SERVER_URL+'/auth/login',{email,password});
    console.log(response,"responseeee")

    return response
  } catch (error) {
    return error;    
  }
}


// desc: Sending the Username and Password to the backend  (signup)
// Used in: ./components/Signup/Signup.js 
const Signup_Post_Call=async(username,email,password,confirmPassword)=>{
    console.log(process.env.REACT_APP_SERVER_URL)
    const response = await axios.post(
     process.env.REACT_APP_SERVER_URL+'/auth/signup',
      { username: username, email, password, confirmPassword }
    );
    // console.log(response)
    return response
    
 
}

export {Login_Post_Call,Signup_Post_Call}